import React from 'react'

export function ActivityIndicator({ size = 48, className = '' }: { size?: number; className?: string }) {
	return (
		<span
			className={`inline-flex items-center justify-center text-primary ${className}`}
			style={{ width: size, height: size }}
			aria-label="loading"
			role="status"
		>
			<svg
				width={size}
				height={size}
				viewBox="0 0 48 48"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{ display: 'block' }}
			>
				<defs>
					<clipPath id="clip0_9917_15168">
						<rect width="48" height="48" fill="white"/>
					</clipPath>
				</defs>
				<g clipPath="url(#clip0_9917_15168)">
					{/* Static outer circle/border */}
					<path
						d="M24.012 0C31.2887 2.60878e-05 38.5671 1.96786 42.3509 5.92578C49.9018 13.5194 49.8965 34.7026 42.218 42.2168C38.4315 46.0733 31.2169 48 24.0032 48C16.7896 47.9999 9.57324 46.0714 5.78543 42.2178C-1.92316 34.6418 -1.92272 13.3605 5.78738 5.78613C9.58354 1.93528 16.797 0 24.012 0ZM24.012 4.25098C17.4868 4.25098 11.521 6.02595 8.81375 8.77148L8.79031 8.7959L8.7659 8.81934C6.02715 11.5101 4.25515 17.4697 4.25515 23.999C4.25523 30.5324 6.02584 36.4941 8.7659 39.1875L8.81765 39.2393C11.5097 41.9793 17.4713 43.7499 24.0032 43.75C30.5353 43.75 36.4951 41.9794 39.1858 39.2393L39.2151 39.209L39.2454 39.1787C41.9334 36.5469 43.7005 30.6881 43.7444 24.252C43.7882 17.6775 42.0584 11.6611 39.3362 8.92383L39.3059 8.89355L39.2776 8.86328C36.5992 6.06147 30.6071 4.251 24.012 4.25098Z"
						fill="currentColor"
						opacity="0.3"
					/>

					{/* Rotating O and X inside */}
					<g className="rotating-elements">
						{/* O element */}
						<path
							d="M15.7024 15.6436C20.3145 15.6436 24.054 19.384 24.054 23.9961C24.0539 28.6081 20.3145 32.3477 15.7024 32.3477C11.0904 32.3476 7.35097 28.6081 7.35086 23.9961C7.35086 19.384 11.0903 15.6436 15.7024 15.6436ZM15.7024 20.1943C13.6028 20.1944 11.9007 21.8964 11.9007 23.9961C11.9008 26.0956 13.6028 27.7978 15.7024 27.7979C17.802 27.7979 19.5041 26.0957 19.5042 23.9961C19.5042 21.8964 17.8021 20.1943 15.7024 20.1943Z"
							fill="currentColor"
							className="o-element"
						/>

						{/* X element */}
						<path
							d="M40.5667 19.1406L35.7112 23.9961L40.5667 28.8506L37.1653 32.252L32.3108 27.3975L27.4553 32.252L24.054 28.8506L28.9095 23.9961L24.054 19.1406L27.4553 15.7402L32.3108 20.5947L37.1653 15.7402L40.5667 19.1406Z"
							fill="currentColor"
							className="x-element"
						/>
					</g>
				</g>
			</svg>
			<style jsx>{`
				.rotating-elements {
					animation: rotate 3s linear infinite;
					transform-origin: 24px 24px;
				}
				.o-element {
					animation: pulse 1.5s ease-in-out infinite;
				}
				.x-element {
					animation: pulse 1.5s ease-in-out 0.75s infinite;
				}
				@keyframes rotate {
					from {
						transform: rotate(0deg);
					}
					to {
						transform: rotate(360deg);
					}
				}
				@keyframes pulse {
					0%, 100% {
						opacity: 0.6;
					}
					50% {
						opacity: 1;
					}
				}
			`}</style>
		</span>
	)
}
